import { ActionMap, createMsg } from 'src/core/engine/actionCreators';
import { Message } from 'src/core/engine/types';

export type FooterTheme = 'light' | 'dark';

export type Messages = {
    ['App.OpenCart']: undefined;
    ['App.OpenCheckout']: undefined;
    ['App.OpenNav']: undefined;
    ['App.ToggleSearch']: boolean;
    ['App.OpenOverlay']: undefined;
    ['App.CloseDrawer']: undefined;
    ['App.AddMessages']: Message[];
    ['App.ClearMessages']: undefined;
    ['App.Log']: unknown;
    ['App.Noop']: undefined;
    ['App.OpenSubNav']: number[];
    ['App.CloseSubNav']: number;
    ['App.CloseAllNavs']: undefined;
    ['App.EnableNav']: undefined;
    ['App.DismissAlert']: undefined;
    ['App.ClearAlert']: undefined;
    ['App.ShowCookieBanner']: undefined;
    ['App.HideCookieBanner']: undefined;
    ['App.ExternalLink']: { url: string; newTab: boolean };
    ['App.Reset']: undefined;
    ['App.SetFooterTheme']: FooterTheme;
    ['App.ResetFooterTheme']: undefined;
    /** Dispatched once, after hydration has committed. */
    ['App.SetRenderEnv']: 'server' | 'browser';
};

export const Msg = createMsg<Messages>();
export const AppMsg = Msg;
export type TypeMap = ActionMap<Messages>;
export type Actions = TypeMap[keyof TypeMap];
export type AppActions = Actions;
